import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

type LocalizedConfig = Record<string, string | undefined> | undefined | null;

interface Props {
  fieldLabel?: string;
  displayLabel?: LocalizedConfig;
  values?: Record<any, string>;
  hardFallback?: string;
}

export const FieldLabelWithFallback = ({
  values,
  fieldLabel,
  displayLabel,
  hardFallback,
}: Props) => {
  const intl = useIntl();

  const { locale } = intl;

  const label = useMemo(() => {
    const localizedValue = displayLabel?.[locale];

    if (localizedValue) {
      if (values) {
        return Object.entries(values).reduce(
          (acc, [key, value]) => acc.replace(`{${key}}`, value),
          localizedValue,
        );
      }

      return localizedValue;
    }

    if (!fieldLabel) return hardFallback ?? displayLabel?.en;

    if (fieldLabel) {
      const fallbackValue = intl.formatMessage(
        { id: fieldLabel, defaultMessage: hardFallback ?? displayLabel?.en },
        values,
      );

      if (fallbackValue) return fallbackValue;
    }

    return displayLabel?.en;
  }, [displayLabel, fieldLabel, hardFallback, intl, locale, values]);

  return <>{label}</>;
};
